/**
 * <h3>常用方法库</h3> 
 * <h5>数组比对</h5>
 * {{#crossLink "bui.inArray"}}{{/crossLink}}: 是否存在,返回index <br>
 * {{#crossLink "bui.compareArray"}}{{/crossLink}}: 是否存在,返回boolean <br>
 * {{#crossLink "bui.removeArray"}}{{/crossLink}}: 删除数组,返回删除后的数组 <br>
 * {{#crossLink "bui.filterArray"}}{{/crossLink}}: 过滤数组,返回条件符合的数组 <br>
 * <h5>对象存储</h5>
 * {{#crossLink "bui.storage"}}{{/crossLink}}: 常用于搜索历史记录, 可以存储普通数据也可以存储对象数据, 返回值必定是数组
 * <h5>页面传参</h5>
 * {{#crossLink "bui.setUrlParams"}}{{/crossLink}}: url跟object生成的字符串 <br>
 * {{#crossLink "bui.getUrlParams"}}{{/crossLink}}: 获取页面的地址中的对象 ?id="123" <br>
 * {{#crossLink "bui.getUrlParam"}}{{/crossLink}}: 获取页面的地址中的指定对象 例如 index.html?id=123&name=首页 可以获取 name值 <br>
 * <h5>平台检测</h5>
 * {{#crossLink "bui.platform"}}{{/crossLink}}: 属于什么系统跟浏览器的检测 <br>
 * <h5>其它常用</h5>
 * {{#crossLink "bui.guid"}}{{/crossLink}}: 生成唯一id <br>
 * 
 * @module Method
 */
;(function (ui,$) {

    /*
     * [obj id转换对象]
     * @param  {[type]} str [ #id || id ]
     * @return {[type]}     [ jquery对象 用于控件的id选择器,做兼容处理]
     *
     * 示例:  var $id = bui.obj("#id");
     */
    ui.obj = function (str) {
        var $id ;

        if( str && typeof str === "object" ){
            $id = $(str);
            return $id;
        }else if( str && typeof str === "string" ){
            if( str.indexOf('#') > -1 ){
                $id = $(str) ;
                return $id;
            }
            if( str.indexOf('.') < 0 && str.indexOf('#') < 0){
               $id = $('#'+str) ; 
               return $id;
            }
        }else{
            $id = null;
            return $id;
        }

    }

    /**
     * 生成唯一id
     * @namespace  bui
     * @class  guid
     * @constructor 
     * @return {string} [唯一id]
     * @example
     *       var guid = bui.guid();
     * 
     */
    ui.guid = function (argument) {
        function S4() {
           return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
        }
        return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    }


/*
 * 常用页面交互操作,传值,取值
 * -------------------------------------------------------
 */ 
    /**
     * 设置传过去的地址转码,默认中文转码
     * @namespace  bui
     * @class  setUrlParams
     * @constructor 
     * @param {string} url [url地址]
     * @param {object} param [object参数]
     * @param {boolean} bool [ true | false 是否转码,默认转码 true]
     * @return {string} [返回字符串]
     * @example
     *       var url = bui.setUrlParams("index.html",{"id":"111"})
     *       console.log(url) //index.html?id=111
     * 
     */
    ui.setUrlParams = function (url,param,bool) {

        var bool = bool == false ? false: true;
        var param = typeof(param) == 'object' ? param: {};
        var params = '', newurl;
        //用javascript的for/in循环遍历对象的属性
        for(var i in param ){ 
            var paramcode = bool ? encodeURIComponent(param[i]): param[i];
            
            params += '&' + i + '=' + paramcode  ; 
        } 
        var newparam =  params.substr(1);//取第1位到结束的字符

        //有对象字面量才修改url地址
        if( newparam == ""){
          newurl = url ;
        }else{
          newurl = url + '?' + newparam;//取第1位到结束的字符
        }

        return newurl;
    };
    /**
     * 获取通过网址传递的参数
     * @namespace  bui
     * @class  getUrlParams
     * @constructor 
     * @param {boolean} bool [ true | false 是否需要中文转码,默认转码 true ]
     * @return {object} [返回网址的参数]
     * @example
     *       var url = bui.getUrlParams()
     *        console.log(url) //{id:111}
     * 
     */
    ui.getUrlParams = function (bool) {
       
       var bool = bool == false ? false: true;
       var url = window.location.search; //获取url中"?"符后的字串
       var theRequest = new Object();
       if (url.indexOf("?") != -1) {
          var str = url.substr(1);
          strs = str.split("&");
          for(var i = 0; i < strs.length; i ++) {
            var val = bool ? decodeURIComponent(strs[i].split("=")[1]): strs[i].split("=")[1];
                
             theRequest[strs[i].split("=")[0]]=val;
          }
       }
       return theRequest;
    };

    /**
     * 获取url的指定字段
     * @namespace  bui
     * @class  getUrlParam
     * @constructor 
     * @param {string} name [指定某个参数名]
     * @return {string} [返回参数值]
     * @example
     *       var val = bui.getUrlParam("id");
     *        console.log(val) //111
     * 
     */
    ui.getUrlParam = function (name) {

        var url = window.location.search;
        //获取url中"?"符后的键值
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = url.substr(1).match(reg);
        if (r != null) return decodeURIComponent(r[2]); return null;
        
    };

/*
 * 常用数据数组操作,检测,对比,过滤,删除 , 数组的本地存储(历史记录)
 * -------------------------------------------------------
 */
    /**
     * 返回数组的位置
     * @namespace  bui
     * @class  inArray
     * @constructor 
     * @param {string} name [字符串]
     * @param {array} arr [数组]
     * @param {string} [key] [object的键名]
     * @return {number} [返回的位置如果大于0,则存在]
     * @example
     *       var arr = [{ "key":1,value:"区"},{ "key":2,value:"王"}];
             var index = bui.inArray( "王", arr, "value" );
             // index = 1;
     * 
     */
    ui.inArray = function (name,arr,key) {
        var arr = arr || [];
        for(var i in arr){  
            try{  

                var arrs = key ? arr[i][key]: arr[i];
                //检测的数组是对象
                if( arrs === name) {
                    return i;
                }
            }catch(e){}
        }
    };
    /**
     * 比对数组是否已经存在
     * @namespace  bui
     * @class  compareArray
     * @constructor 
     * @param {string} name [字符串]
     * @param {array} arr [数组]
     * @param {string} [key] [object的键名]
     * @return {boolean} [返回true|false]
     * @example
     *       var arr = [{ "key":1,value:"区"},{ "key":2,value:"王"}];
             var index = bui.compareArray( "王", arr, "value" );
            // index = true;
     * 
     */
    ui.compareArray = function (name,arr,key) {
        var arr = arr || [];
        for(var i in arr){  
            try{  

                var arrs = key ? arr[i][key]: arr[i];
                
                //检测的数组是对象
                if( arrs === name) {

                    return true;
                }
            }catch(e){}
        }
        
    };
    /**
     * 删除存在的数组对象
     * @namespace  bui
     * @class  removeArray
     * @constructor 
     * @param {string} name [字符串]
     * @param {array}  arr [数组]
     * @param {string} [key] [object的键名]
     * @return {array} [返回删除后的数组]
     * @example
     *      var arr = [{ "key":1,value:"区"},{ "key":2,value:"王"}];
            var index = bui.removeArray( "王", arr, "value" );
            // index =  [{ "key":1,value:"区"}];
     * 
     */
    ui.removeArray = function (name,arr,key) {  
        var data = arr || [];
        for(var i in data){  
            try{  
                var arrs = key ? data[i][key]: data[i];

                if( arrs === name) {
                    //delete arr[item];
                    data = data.splice(i,1); 
                } 
            }catch(e){}
        };
        return arr;
    };  
    /**
     * 过滤数组
     * @namespace  bui
     * @class  filterArray
     * @constructor 
     * @param {string} name [字符串]
     * @param {array}  arr [数组]
     * @param {string} [key] [object的键名]
     * @return {array} [返回条件为true的数组]
     * @example
     *      var arr = [{ "key":1,value:"区"},{ "key":2,value:"王"}];
            var index = bui.filterArray( "王", arr, "value" );
            // index =  [{ "key":1,value:"区"}];
     * 
     */
    
    ui.filterArray = function (name,arr,key) {
        var data = [];
        var arr = arr || [];

        for(var i in arr){  
            try{  

                var arrs = key ? arr[i][key]: arr[i];
                var keyword = new RegExp(name);
                //检测的数组是对象
                if( keyword.test(arrs) )  {
                    data.push(arr[i]);
                }

            }catch(e){}
        }

        return data;
    };

    /**
     * 对象存储
     * @namespace  bui
     * @class  storage
     * @constructor 
     * @param {number} [size] [存储的数据大小,默认是1]
     * @example 
     *
    普通使用示例:
     *
        // 保存数据
        var storage = bui.storage();
            storage.set("username","王伟深");
            storage.set("username","区柏荣");

       // 获取数据
       var data = storage.get("username");

       // 默认只存储一条数据,所以第一条数据会被覆盖
       //console.log( data ) ["区柏荣"]

     * 对象存储示例: 
     *
        // 保存数据
        var storage = bui.storage(2);
        //存储第1条数据
        storage.set("userinfo",{"id":"n1","name":"王伟深"},"id");
        //存储第2条数据
        storage.set("userinfo",{"id":"n2","name":"区柏荣"},"id");
        //删除1条数据,通过name值比对
        storage.remove("userinfo","王伟深","name");
        // 获取数据
        var data = storage.get("userinfo");
        
         //console.log( data ) [{"id":"n2","name":"区柏荣"}]
     * 
     */
    ui.storage = function (size) {

        var names = [];
        //全局配置，如果没有就默认1
        var size = size || 1;

        /**
         * 保存数据
         *  @method set
         *  @chainable
         *  @param {string} name [存储的变量名]
         *  @param {object} item [存储的变量名]
         *  @param {string} keyname [存储的数据的比对字段,不传会导致数据重复,size为1 则都会替换]
         *  @example 
            var storage = bui.storage();
                //普通数组无需传字段,不传最后的值默认只存储1条数据
                storage.set("username","王伟深");
                //存储对象示例
                storage.set("userinfo",{"id":"n1","name":"王伟深"},"id");
                
         */
         function set(name,item,keyname) {

                //获取已有的历史记录
                var data = localStorage.getItem(name);
                
                var datas = [];
                var datastring = '';

                var items = keyname ? item[keyname]: item;

                //添加第一条数据
                if( data === null ){

                    datas.push(item);

                    datastring = JSON.stringify(datas);

                    localStorage.setItem(name,datastring);


                }else{
                    
                    var dataobj = JSON.parse(data);
                    var bool = keyname ? ui.compareArray(items,dataobj,keyname): ui.compareArray(items,dataobj);

                    //如果存在就覆盖,不存在就增加
                    if( !bool  ){
                        
                        var datai = dataobj.unshift(item);
                        //如果超过配置的记录，就删除最后一条
                        if( dataobj.length > size ){
                            //删除最后一个元素
                            dataobj.pop();
                        }

                        datastring = JSON.stringify(dataobj);
                        
                        localStorage.setItem(name,datastring);

                    }else {
                        
                         // 覆盖记录
                        ui.removeArray(items,dataobj,keyname);

                        var datai = dataobj.unshift(item);
                        
                        datastring = JSON.stringify(dataobj);
                        
                        localStorage.setItem(name,datastring);

                    }
                    
                };

                return this;
            }
        
        /**
         * 获取存储的数组
         *  @method get
         *  @param {string} name [存储的变量名]
         *  @param {bollean} bool [ true | false 默认输出obj]
         *  @return {array} 返回数组
         *  @example 
                
            var storage = bui.storage();
            
            // 获取数据
            var data = storage.get("username");
            //console.log( data ) ["区柏荣"]
                
         */
        function get(name,bool) {
        
            var bool = bool == false ? false: true;

            var datastr = localStorage.getItem(name);

            var data;
            if( datastr != null && datastr != undefined && bool){
                try{

                    data = JSON.parse(datastr);

                }catch(e){
                    console.log(e);
                }

            }else{
                data = datastr || "";
            }
            return data;
        }

        /**
         * 删除某个字段
         *  @method remove
         *  @chainable
         *  @param {string} name [存储的变量名]
         *  @param {string} item [ 删除的数据,例如 name = "abcd" 的数据,那就传 "abcd" ]
         *  @param {string} key [ 这个要删除的字段在哪个字段里 ]
         *  @example 
                
            var storage = bui.storage();

                // 删除普通数据
                storage.remove("username","王伟深");

                // 删除对象数据,通过id比对
                storage.remove("userinfo","n1","id");
                
         */
        function remove(name,item,key) {

            key = key || null;
            //检查字段是否为空
            if( !name  ){
                ui.hint("要删除的字段不能为空");
                return ;
            }
            //如果有传参数就只删除记录的某一条
            if( item ){

                var datastr = localStorage.getItem(name),
                    dataobj = null;

                if( datastr ){
                    try{

                        dataobj = JSON.parse(datastr);

                    }catch(e){
                        console.log(e);
                    }
                }else{
                    return;
                }

                //如果存在就删除指定的记录
                if( ui.compareArray(item,dataobj,key)  ){
                    
                    ui.removeArray(item,dataobj,key);
                    
                    datastring = JSON.stringify(dataobj);
                    
                    localStorage.setItem(name,datastring);
                }

            }else{

                //删除整个记录
                localStorage.removeItem(name);
            };
            
            return this;

        };

        /**
         * 清空本地存储
         *  @method clear
         *  @chainable
         *  @example 
            var storage = bui.storage();
                storage.clear();
                
         */
        function clear() {

            localStorage.clear();

            return this;
        };
        return {
            get: get,
            set: set,
            remove: remove,
            clear: clear
        }
    };

    /**
     * 仅用于安卓及ios移动平台的检测
     * @namespace  bui
     * @class  platform
     * @constructor 
     * @return {boolean} 返回布尔值
     * @example 
     *  if( bui.platform().isAndroid() ){
     *      //如果是安卓做什么事情
     *    }
     * 
     */
    ui.platform = function (argument) {

        var u = navigator.userAgent;

        /**
         * 是否是window平台
         *  @method isWindow
         *  @chainable
         *  @return {boolean} [true | false]
         *  @example 
            
               var bool = bui.platform().isWindow();
                
         */
        function isWindow (argument) {
            return /Windows NT/i.test(u) ;
        }
        /**
         * 是否是mac平台
         *  @method isMac
         *  @chainable
         *  @return {boolean} [true | false]
         *  @example 
            
               var bool = bui.platform().isMac();
                
         */
        function isMac (argument) {
            return /Macintosh/i.test(u) ;
        }
        /**
         * 是否是安卓手机
         *  @method isAndroid
         *  @chainable
         *  @return {boolean} [true | false]
         *  @example 
            
               var bool = bui.platform().isAndroid();
                
         */
        function isAndroid (argument) {
            return /(Android|Linux)/i.test(u) ;
        }
        /**
         * 是否是Iphone
         *  @method isIphone
         *  @chainable
         *  @return {boolean} [true | false]
         *  @example 
            
               var bool = bui.platform().isIphone();
                
         */
        function isIphone (argument) {
            return /(iPhone)/i.test(u);
        }
        /**
         * 是否是Ipad
         *  @method isIpad
         *  @chainable
         *  @return {boolean} [true | false]
         *  @example 
            
               var bool = bui.platform().isIpad();
                
         */
        function isIpad (argument) {
            return /(iPad)/i.test(u);
        }
        /**
         * IOS平台包括Iphone Ipad
         *  @method isIos
         *  @chainable
         *  @return {boolean} [true | false]
         *  @example 
            
               var bool = bui.platform().isIos();
                
         */
        function isIos (argument) {
            return /(iPhone|iPad|iOS)/i.test(u);
        }
        /**
         * 微信浏览器
         *  @method isWeiXin
         *  @chainable
         *  @return {boolean} [true | false]
         *  @example 
            
               var bool = bui.platform().isWeiXin();
                
         */
        function isWeiXin (argument) {
            return /(micromessenger)/i.test(u) ;
        }
        /**
         * BT应用
         *  @method isBingotouch
         *  @chainable
         *  @return {boolean} [true | false]
         *  @example 
            
               var bool = bui.platform().isBingotouch();
                
         */
        function isBingotouch (argument) {
            return /(crosswalk)/i.test(u) ;
        }
        return {
            isAndroid: isAndroid,  //是否是安卓
            isIphone: isIphone,    //是否是Iphone
            isIpad: isIpad,        //是否是Ipad
            isIos: isIos,          //是否是IOS系统,包含Iphone及Ipad
            isWeiXin: isWeiXin,    //是否是微信浏览器
            isBingotouch: isBingotouch,    //是否是BT应用
            isMac: isMac,          //是否是Mac系统
            isWindow: isWindow     //是否是Window系统
        }
    };
    

    return ui;

})( bui || {}, libs );
